import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

const DncModalSchema = (): yup.AnyObjectSchema => {
  const { t } = useTranslation();
  const reason = t('common.formErrorMessages.reason_required');
  const schema = yup
    .object({
      dncNumber: yup.string().required('Number is a required'),
      note: yup.string().trim().max(255).required('Note is a required!'),
      reason: yup
        .object()
        .nullable()
        .required(reason)
        .shape({
          value: yup.string().required(reason),
          label: yup.string().required(reason),
        }),
    })
    .required();

  return schema;
};
export default DncModalSchema;
